import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import {atom, useRecoilState} from 'recoil';
import {annotationChartYAxisAtom, isCurrentBloodSugarAtom} from '../../../states/recoilState';
import { useTranslation } from "react-i18next";
import { parseServerTime } from "../../../utils/serverTime";

const AnnotationChart = (props) => {
  const { t:translate, i18n } = useTranslation();
  const [maxData, setMaxData] = useState(null);
  const [minData, setMinData] = useState(null);
  const [chartOption, setChartOption] = useState([]);
  const [chartSeries, setChartSeries] = useState([]);

  const [isCurrentBloodSugar, setIsCurrentBloodSugar] = useRecoilState(isCurrentBloodSugarAtom);
  const [annotationChartYAxis, setAnnotationChartYAxis] = useRecoilState(annotationChartYAxisAtom);

  const [chartEventList, setChartEventList] = useState([
    {
      x: 0,//props.chartData.eventList[i].created_at,
      borderColor: '#00E396',
      label: {
        borderColor: '#00E396',
        style: {
          color: '#fff',
          background: '#00E396'
        },
        text: '테스트',
        click: () => onClickEvent('123'),
      }
    }
  ]);
  
  const onClickEvent = (input) => {
    alert(input);
  };
    
  // let tempList1 = [];
  // let tempList2 = [];
  // for(let i = 0; i < 10000; i++){
  //   let randomNumber = Math.floor(Math.random() * 100) + 1;
  //   tempList1.push(`${i+1}`);
  //   tempList2.push(randomNumber);
  // }

  // useEffect(()=>{
  //   setChartOption(tempList1);
  //   //setChartSeries(tempList2);
  // },[]);
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1;
  const day1 = new Date().getDate();

  // (UTC-first 2026-09-23) x는 실제 순간(epoch) + xaxis.labels.datetimeUTC:false → 브라우저 시간대로 표시

  const updateGraph = () => {
    if(props.chartData !== null && props.chartData !== undefined && props.chartData.length !== 0){
      //그래프 데이터
      let tempSeriesList = [];
      let tailCount = 0;
     
      for(let i = 0; i < props.chartData.valueList.length; i += props.graphXminutes){
        tailCount++;
        //그래프 맨 앞에 0주기
        if(i === 0){
          let zeroMoment = parseServerTime(props.chartData.dateTimeList[0]);
          let zeroUtcDate = zeroMoment === null ? null : zeroMoment.valueOf();
          let zeroData = zeroMoment === null ? null : zeroMoment.clone().startOf('day').valueOf();
          if(zeroData !== null && zeroData < zeroUtcDate){
            let tempObject = {
              x: zeroData,                 //props.chartData.dateTimeList[i],
              y: null
            };
            tempSeriesList.push(tempObject);
          }
        }

        let tempMoment = parseServerTime(props.chartData.dateTimeList[i]);
        let utcDate = tempMoment === null ? null : tempMoment.valueOf();
        let tempObject = null;
        
        if(!isCurrentBloodSugar){
          tempObject = {
            x: utcDate,                 //props.chartData.dateTimeList[i],
            y: Math.round(props.chartData.valueList[i]*100)/100//isCurrentBloodSugar ? Math.round(props.chartData.valueList[i]*100)/100 : Math.floor(props.chartData.valueList[i]) //전류면 소수점 2자리까지 보여주게 하기
          };
        }
        else{
          tempObject = {
            x: utcDate,                 //props.chartData.dateTimeList[i],
            y: Math.floor(props.chartData.valueList[i])
          };
        }
        tempSeriesList.push(tempObject);
        //baseDateTime = new Date(baseDateTime.getTime() + 10* 2000);
      }

      //그래프가 다 안채워졌을 경우, 뒤를 y값 null로 꽉 채워주기          
      let tailMoment = parseServerTime(props.chartData.dateTimeList[tailCount - 1]);

      let utcDate = tailMoment === null ? null : tailMoment.clone().endOf('day').startOf('second').valueOf();
      
      let tempObject = {
        x: utcDate,                
        y: null
      };
 
      tempSeriesList.push(tempObject);
      setChartSeries(tempSeriesList);
      
      //어노테이션 데이터
      let tempAnnotationList = [];
      
      for(let i = 0; i < props.chartData.eventList.length; i++){
        let typeString = '';
        let contentString = props.chartData.eventList[i].content;
        let colorString = '';
        //1401이면 식사
        if(props.chartData.eventList[i].contents_id == 1401){
          typeString = '식사';
          colorString = '#E9979F';
        }
        //1402이면 활동
        else{
          typeString = '활동';
          colorString = '#B9D7E3';
        }
        
        let eventMoment = parseServerTime(props.chartData.eventList[i].created_at);
        let tempObject = {
          x: eventMoment === null ? null : eventMoment.valueOf(),
          borderColor: colorString,//'#00E396',
          //offsetY: 20,
          label: {
            borderColor:colorString,// '#00E396',
            style: {
              color: '#fff',
              background: colorString,//'#00E396' 
            },
            text: typeString,//props.chartData.eventList[i].content,
            click: () => onClickEvent(contentString),
          }
        }

        tempAnnotationList.push(tempObject);
      }

      //Max Min 데이터
      let tempAnnotation = parseServerTime(props.chartData.maxValue.created_at);
      let tempUtcDate = tempAnnotation === null ? null : tempAnnotation.valueOf();
      setMaxData({
        x: tempUtcDate,
        y: props.chartData.maxValue.value,
        marker: {
          size: 4,
          fillColor: '#D32F2F',
          strokeColor: '#D32F2F',
          ///radius: 10,
          //cssClass: 'apexcharts-custom-class'
        },
        // label: {
        //   borderColor: '#04B431',
        //   offsetY: 0,
        //   style: {
        //     color: '#fff',
        //     background: '#04B431',
        //   },
    
        //   text: 'max',
        // }
      });
      tempAnnotation = parseServerTime(props.chartData.minValue.created_at);
      tempUtcDate = tempAnnotation === null ? null : tempAnnotation.valueOf();
      setMinData({
        x: tempUtcDate,
        y: props.chartData.minValue.value,
        marker: {
          size: 4,
          fillColor: '#ED6C02',
          strokeColor: '#ED6C02',
          radius: 10,
          //cssClass: 'apexcharts-custom-class'
        },
        // label: {
        //   borderColor: '#FF0040',
        //   offsetY: 0,
        //   style: {
        //     color: '#fff',
        //     background: '#FF0040',
        //   },
    
        //   text: 'min',
        // }
      });

      //Calibration 이벤트 리스트
      for(let i = 0; i < props.chartData.calibrationList.length; i++){
        let calibMoment = parseServerTime(props.chartData.calibrationList[i].created_at);
        let tempObject = {
          x: calibMoment === null ? null : calibMoment.valueOf(),
          borderColor: '#7C7BBA',//'#00E396',
          label: {
            borderColor: '#7C7BBA',// '#00E396',
            style: {
              color: '#fff',
              background: '#7C7BBA',//'#00E396'
            },
            text: props.chartData.calibrationList[i].value,//props.chartData.eventList[i].content,
            click: () => onClickEvent(props.chartData.calibrationList[i].value),
          }
        }
        tempAnnotationList.push(tempObject);
      }
      setChartEventList(tempAnnotationList);
    }
  }

  useEffect(() => {
    updateGraph();
  }, [isCurrentBloodSugar]);

  useEffect(() => {
    updateGraph();
  },[props.graphXminutes])

  useEffect(()=>{
    updateGraph();
  }, [props.chartData]);

  const options = {
    chart: {
      id: 'basic-line',
      type: 'line',
      // toolbar:{
      //   show: true,
      //   tools:{
      //     zoomin: false
      //   }
      // },
      animations: {
        enabled: false
        //speed: 200
      },
      zoom: {
        type: 'xy',
        enabled: true,
        //autoScaleYaxis: true
      },
    },

    xaxis: {
      type: 'datetime',
      labels: {
        datetimeUTC: false // x가 실제 순간이므로 브라우저 시간대로 라벨
      },
      tooltip: {
        enabled: false
      }
      //categories: chartOption//['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    },

    annotations:{
      xaxis: chartEventList,
      yaxis: !isCurrentBloodSugar ? 
      []
      : 
      [
        {
          y: props.targetGlucose.low,
          y2: props.targetGlucose.high,
          borderColor: '#000',
          fillColor: '#DCF0FA',
          label: {
            text: props.targetGlucose.low + ' - ' + props.targetGlucose.high
          }
        }
      ],
      points: [
        maxData,
        minData
      ]
    },

    stroke: {
      curve: 'smooth',
      width:1
    },
    markers:{
      size:0
    },
    tooltip : {
      enabled: true,
      x:{
        format: 'MM/dd HH:mm'
      },
      followCursor: true // Add this line to enable tooltip to follow the cursor
    }
  };
  
  options.yaxis = isCurrentBloodSugar?{
    min: 0,
    max: 350
  }: {
    min: annotationChartYAxis.min,
    max: annotationChartYAxis.max
  };

  const series = [
    {
      name: translate('glucose'),
      data: chartSeries,//[80, 40, 25, 50, 49, 21, 70, 51, 60, 80, 45, 35],
    },
  ];

  return (
    <ReactApexChart options={options} series={series} type="line" height={170} />
  );
};

export default AnnotationChart;
